// src/components/Sections2/PTGCModal.jsx
import React from "react";
import Modal from "react-modal";
import Leaderboard from "./leaderboard";

Modal.setAppElement("#root");

const PTGCModal = ({ isOpen, onClose, activeTab, setActiveTab }) => {
  const handleModalOpen = () => {
    document.body.style.overflow = "hidden"; // prevent scroll when modal open
  };

  const handleModalClose = () => {
    document.body.style.overflow = "auto";
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleModalClose}
      onAfterOpen={handleModalOpen}
      contentLabel="PTGC Modal"
      className="My__Overlay"
      overlayClassName="ReactModal__Overlay"
    >
      <div className="My__OverlayIn">
        <div className="PTGCSEC popupcenter">
          <button
            className="nobg closepopup d-flex align-items-center gap-1"
            onClick={handleModalClose}
          >
            <span className="underline">Close</span>
            <img src="./images/XCircle.svg" className="img-fluid" alt="close" />
          </button>
          <div className="container">
          <div className="text-center">
            <h2 className="mb-0 mt-2 w-100 good_times goldFont">
              Why PulseChain & pTGC Stand Out
            </h2>
          </div>

          {/* Tabs Navigation */}
          <div className="d-flex justify-content-center ">
            <div className="tabs nav nav-pills mb-1 gap-1 mt-4 text-center">
              <button
                className={`nav-link ${activeTab === "first" ? "active" : ""}`}
                onClick={() => setActiveTab("first")}
              >
                Pulsechain & Other Chains
              </button>
              <button
                className={`nav-link ${activeTab === "chains" ? "active" : ""}`}
                onClick={() => setActiveTab("chains")}
              >
                PTGC & Pulsechain
              </button>
              <button
                className={`nav-link ${activeTab === "tokens" ? "active" : ""}`}
                onClick={() => setActiveTab("tokens")}
              >
                PTGC & Other Tokens
              </button>
            </div>
          </div>

          {/* Tabs Content */}
          <div className="tabContent mt-0">

            {activeTab === "first" && (
              <div className="tab-pane">

      <div className="gredientBG subcontent subPad SRTOP py-0">
        <div className="row justify-content-center">
          <div className="col-sm-12">
        <div className="row m-0">
          <div className="col-sm-6 p-0 borderRight mobBorderBottomAdd991">

            <div className="compare py-3 pb-0">
        <h4 className="good_times goldFont"><span></span><span>Pulsechain</span></h4>
          <ul className="mb-0">
            <li><i className="fa-solid fa-circle-check"></i> Significant upside potential</li>
            <li><i className="fa-solid fa-circle-check"></i> Robust design (Ethereum 2.0 fork)</li>
            <li><i className="fa-solid fa-circle-check"></i> Decentralized</li>
            <li><i className="fa-solid fa-circle-check"></i> 100% uptime</li>
            <li><i className="fa-solid fa-circle-check"></i> Deflationary / Scarce</li>
            <li><i className="fa-solid fa-circle-check"></i> SEC cleared</li>
            <li><i className="fa-solid fa-circle-check"></i> Native DEXs and bridges</li>
          </ul>
            </div>
          </div>
          <div className="col-sm-6 p-0 ">

            <div className="compare compare2  py-3 pb-0">
        <h4 className="good_times goldFont"><span></span><span>Other Chains</span></h4>
          <ul className="mb-0">
            <li><i className="fa-solid fa-circle-xmark"></i> Limited upside potential</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Venture capital/foundation sell pressure</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Centralized</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Prone to network outages</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Inflationary</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Not SEC cleared</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Reliance on third-party DEXs and bridges</li>
          </ul>
            </div>
          </div>
            </div>
          </div>
        </div>
      </div>
              </div>
            )}
            {activeTab === "chains" && (
              <div className="tab-pane">
      <div className="gredientBG subcontent subPad SRTOP py-0">
                  <div className="row justify-content-center">
          <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-6">
            <div className=" py-4">
              <h4><img src="./images/ptgc/logo.svg" className="img-fluid campareLogos" /></h4>
              <p className=" f14" style={{opacity:0.7}}>PTGC is the first of its kind- deflationary, yield-paying store-of-value token built to endure multiple market cycles with a focus on price appreciation. It features no admin keys, burned liquidity, and 100% uptime—ensuring a transparent, self-custodied asset.Holders are rewarded through a built-in, fee-based system that retains more value within the ecosystem than it distributes. Governed by its DAO and driven by a passionate community, PTGC functions as an index of PulseChain’s top assets—including HEX, PLS, PLSX, INC, and more. This design creates perpetual mechanical demand fueled by market volatility (the one constant in crypto), forging an enduring narrative of growth, strength, and resilience.</p>
            </div>
          </div>
          <div className="col-sm-6">
            <div className=" py-4">
              <h4><img src="./images/wordmark.png" className="img-fluid campareLogos" /></h4>
              <p className=" f14" style={{opacity:0.7}}>
PulseChain is a decentralized EVM blockchain, similar to Ethereum, offering lightning-fast transactions, near-zero fees, and 100% uptime. As one of the only chains cleared by the SEC, it’s a deflationary evolution of Ethereum designed for massive scalability and unstoppable DeFi. Backed by a thriving community, a native DEX, and bridge, PulseChain is led by visionary innovation to empower investors in capturing the next wave of crypto growth. Still in its early stages, it offers substantial price appreciation potential thanks to strong product-market fit, supply controls, and built-in demand.

</p>
            </div>
          </div>
            </div>
          </div>
          </div>
        </div>
              </div>
            )}
            {activeTab === "tokens" && (
              <div className="tab-pane">
                <div className="tokenNG mb-4  relative overHide">
                  <div className="shapT1"></div>
                  <div className="shapT2"></div>
                  <div className="p-0 relative">
                    <div className="row m-0">
          <div className="col-sm-6 p-0 borderRight mobBorderBottomAdd991">

            <div className="compare py-3 compare2 pb-0">
        <h4 className="good_times goldFont"><span></span><span>PTGC</span></h4>
          <ul className="mb-0">
            <li><i className="fa-solid fa-circle-check"></i> Decentralized</li>
            <li><i className="fa-solid fa-circle-check"></i> Liquidity is burned and locked</li>
            <li><i className="fa-solid fa-circle-check"></i> Price growth with multi-cycle design</li>
            <li><i className="fa-solid fa-circle-check"></i> Deflationary / Scarce</li>
            <li><i className="fa-solid fa-circle-check"></i> Utility-driven and mechanically sustained demand</li>
            <li><i className="fa-solid fa-circle-check"></i> Designed for market adaptability</li>
            <li><i className="fa-solid fa-circle-check"></i> Yield for holding</li>
          </ul>
            </div>
          </div>
          <div className="col-sm-6 p-0 ">

            <div className="compare compare2  py-3 pb-0">
        <h4 className="good_times goldFont"><span></span><span>Other Tokens</span></h4>
          <ul className="mb-0">
            <li><i className="fa-solid fa-circle-xmark"></i> Centralized</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Liquidity can be pulled</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Limited growth potential</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Inflationary</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Temporary demand and shifting narratives</li>
            <li><i className="fa-solid fa-circle-xmark"></i> Struggle to adapt to market evolution</li>
            <li><i className="fa-solid fa-circle-xmark"></i> No passive yield</li>
          </ul>
            </div>
          </div>
            </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        </div>
      </div>

      {/* Modal Styles */}
      <style jsx="true">{`
      `}</style>
    </Modal>
  );
};

export default PTGCModal;
